/*
 * @Author: duyaoyao
 * @Date: 2020-09-04 11:20:43
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-04-13 20:30:44
 */
import Vue from 'vue';
import VueRouter from 'vue-router';
Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'errorPage',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/error/index.vue'),
    meta: {
      title: '商品质量追溯网',
    },
  },
];

const router = new VueRouter({
  mode: 'hash',
  routes,
});

export default router;
